export const environment = {
  sandbox: true,
  apiUrl: 'https://sandbox-wscard.wacepay.io/api/v1',
  ws: 'wss://sandbox-wscard.wacepay.io/api/v1',
  mode: 'sandbox'
};